import React from 'react';
import styled, { injectGlobal } from 'react-emotion';
import { fontSize } from 'styled-system';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Navigation from '../components/Navigation';
import colors from '../utils/colors';

/* eslint-disable */
import normalize from 'normalize.css';
import index from './index.css';
injectGlobal`
  * {
      font-family: Tajawal, -apple-system, BlinkMacSystemFont,
             'avenir next', avenir,
             'helvetica neue', helvetica,
             ubuntu,
             roboto, noto,
             'segoe ui', arial,
             sans-serif;
      box-sizing: border-box;
  };
  html {
    height: 100%;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  };
  body {
    height: 100%;
    background-image: linear-gradient(
        to right top,
        #2b5697,
        #8d54a3,
        #d64e8b,
        #fd635a,
        #f69616 50%,
        #f69616
      );
    background-attachment: fixed;
    & #___gatsby {
      height: 100%
    }
  };
  a {
    text-decoration: none;
    color: inherit;
  };
  a:hover {
    cursor: pointer;
  };
  h1, h2, h3, h4, h5, h6 {
    color: ${colors.primary};
    margin-bottom: 0.1em;
  };
  h1, h2 {
    color: ${colors.primary};
    font-family: 'IM Fell English SC';
  };
  p {
    margin: 0;
    color: ${colors.primary};
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  };
  ul {
    margin: 0;
    padding: 0;
  }
`;
/* eslint-enable */

const FontConfig = styled.div`
  ${fontSize};
  height: 100%;
`;

const Container = styled.div`
  height: 100%;
`;

const Layout = ({ children, data }) => (
  <Container>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Owla ja kadonnut walkia' },
        { name: 'keywords', content: 'tanssi, teatteri, oulu' }
      ]}
    />
    <FontConfig fontSize={[2, 3, 4]}>
      <Navigation />
      {children()}
    </FontConfig>
  </Container>
);

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js